// Social Api


export default {
    init() {
        this.facebookInit();


    },
    facebookInit() {

        window.fbAsyncInit = function () {
            FB.init({
                appId: window.GrandsEspaces.id_facebook,
                autoLogAppEvents: true,
                xfbml: true,
                version: 'v3.2'
            });

        };

    },


};


// WEBPACK FOOTER //
// ./assets/js/libs/SocialApi.js